import { Controller } from "@hotwired/stimulus";
import { formatSignedHours, signClass } from "../schedule_helpers";

export default class extends Controller {
  static targets = ["hours", "before", "after"];
  static values = { accumulatedBefore: Number };

  connect() {
    this.update();
  }

  update() {
    const paid = Math.round((parseFloat(this.hoursTarget.value.replace(",", ".")) || 0) * 60);
    this.render(this.beforeTarget, this.accumulatedBeforeValue);
    this.render(this.afterTarget, this.accumulatedBeforeValue - paid);
  }

  render(element, minutes) {
    element.textContent = `${formatSignedHours(minutes)} h`;
    element.className = signClass(minutes);
  }
}
